module.exports = __webpack_public_path__ + "static/media/icon-copy-email.cc850b33.svg";